/**
 * 日期格式化
 * @param {时间对象} date 
 * @param {字符串} str 
 * @param {布尔值} isTime 
 * @param {tiemStr} str 
 */
function formatDate(date, isTime = false, str = '-', tiemStr = ':') {
  date = new Date(date)
  let Y = date.getFullYear()
  let M = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  if (isTime) {
    let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + str + M + str + D + ' ' + h + tiemStr + m + tiemStr + s
  }
  return Y + str + M + str + D
}

//工具方法
let timer, flag;
/**
 * 节流原理：在一定时间内，只能触发一次
 *
 * @param {Function} func 要执行的回调函数
 * @param {Number} wait 延时的时间
 * @param {Boolean} immediate 是否立即执行
 * @return null
 */
function throttle(func, wait = 500, immediate = true) {
  if (immediate) {
    if (!flag) {
      flag = true;
      // 如果是立即执行，则在wait毫秒内开始时执行
      typeof func === "function" && func();
      timer = setTimeout(() => {
        flag = false;
        clearTimeout(timer);
      }, wait);
    }
  } else {
    if (!flag) {
      flag = true;
      // 如果是非立即执行，则在wait毫秒内的结束处执行
      timer = setTimeout(() => {
        flag = false;
        typeof func === "function" && func();
        clearTimeout(timer);
      }, wait);
    }
  }
}

/**
 * 获取本月一号时间
 */
function theMonthFirstDay() {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  month = month <= 9 ? "0" + month : month;
  let day = "01";
  return year + '-' + month + '-' + day;
}
/**
 * 获取今天 时间
 */
function theMonthFirstOnDay() {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  month = month <= 9 ? "0" + month : month;
  day = day <= 9 ? "0" + day : day
  return year + '-' + month + '-' + day;
}
/**
 * 防抖原理：一定时间内，只有最后一次操作，再过wait毫秒后才执行函数
 * 
 * @param {Function} func 要执行的回调函数 
 * @param {Number} wait 延时的时间
 * @param {Boolean} immediate 是否立即执行 
 * @return null
 */
let timeout = null;
function debounce(func, wait = 500, immediate = false) {
  // 清除定时器
  if (timeout !== null) clearTimeout(timeout);
  // 立即执行，此类情况一般用不到
  if (immediate) {
    var callNow = !timeout;
    timeout = setTimeout(function () {
      timeout = null;
    }, wait);
    if (callNow) typeof func === 'function' && func();
  } else {
    // 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
    timeout = setTimeout(function () {
      typeof func === 'function' && func();
    }, wait);
  }
}
/**
 * 获取今天 时间
 */
function theMonthFirstOnDayday() {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  month = month <= 9 ? "0" + month : month;
  day = day <= 9 ? "0" + day : day
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let seconds = date.getSeconds();
  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
}
export default debounce

export {
  formatDate,
  throttle,
  debounce,
  theMonthFirstDay,
  theMonthFirstOnDay,
  theMonthFirstOnDayday
}